<!-- title -->
<div class="inputTitle" *ngIf="!trim && label">
  <span>{{label}}<i MatSuffix matTooltip={{tooltipName}} matTooltipPosition="right" [matTooltipHideDelay]="delay"
      id="i1" class="flaticon-message" *ngIf="tooltipIcon"></i></span>
</div>

<!-- <div >  -->
<div class="intellisense" tabindex="-1" (focusout)="onFocusOut($event)" (focusin)="onFocusIn($event)">
  <mat-form-field appearance="outline" *ngIf="isEditable" [class.trim-auto-search]="trim"
    [class.errorBorder]="errors?.length">
    <mat-chip-list #chipList *ngIf="multiple">
      <mat-chip *ngFor="let item of data, let idx = index">
        <!-- <img matChipAvatar src="/assets/images/icons/maps/{{country}}.svg" /> -->
        {{getDisplay(item)}}
        <button matChipRemove (click)="removeFromList(idx)">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-list>
    <input matInput autocomplete="off" type="text" [placeholder]="placeholder" [ngModel]="searchBoxText"
      (keyup)="onSearchKeyUp($event)" (keydown)="blackHole($event)" #searchBox class="search-input"
      [disabled]="disabled">
    <!-- <mat-autocomplete #auto="matAutocomplete">
    <mat-option *ngFor="let item of options" (click)="selectItem(item)">
      <span>{{getDisplay(item)}}</span>
    </mat-option>
  </mat-autocomplete> -->
    <mat-icon matSuffix [hidden]="trim && data">search</mat-icon>
  </mat-form-field>

  <div class="dropdown" *ngIf="showOptions">
    <div class="hover">
      <div class="loading-row" *ngIf="loading">Loading</div>
      <ng-container *ngIf="!loading">
        <div class="option-item" *ngFor="let item of options, let idx = index"
          [class.is-selected]="selectedIndex == idx" (click)="selectItem(idx)">
          <mat-option>
            <span>
              {{getDisplay(item)}}
            </span>
          </mat-option>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- </div> -->

<div class="viewLable" *ngIf="!isEditable">
  <span>{{getDisplay(_data)}}</span>
</div>

<ul *ngIf="errors?.length" class="errorList">
  <li *ngFor="let item of errors" class="error">{{item}}</li>
</ul>